// extracted by mini-css-extract-plugin
module.exports = {"container":"rating_container__PwTzZ","star":"rating_star__nCVnc","centered":"rating_centered__Isbd0","readOnly":"rating_readOnly__mAbkC"};